import { gray100 } from './colors';
import { sideBarWidth, spHeaderHeight } from './location';

/**
 * 管理画面の共通レイアウトスタイル
 * 完了系ページ（CompanyPlanChangeComplete, CompanyUserLimitChangeComplete, OcrCreditAddComplete）
 * および権限エラー表示（AdminNoPermissionPage）で共通利用
 */
export const adminCompletePageStyles = {
  page: {
    height: '100vh',
    display: 'flex',
    '@media (max-width: 960px)': {
      flexDirection: 'column',
      paddingTop: '0',
      justifyContent: 'flex-start',
    },
  },
  sidebar: {
    backgroundColor: gray100,
    height: '100vh',
    position: 'fixed',
    width: sideBarWidth,
    '@media screen and (max-width:960px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '-webkit-fill-available',
    marginLeft: sideBarWidth,
    minHeight: '100vh',
    '@media (max-width: 960px)': {
      marginTop: spHeaderHeight,
      marginLeft: 0,
      minHeight: `calc(100vh - ${spHeaderHeight})`,
    },
  },
};
